import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        material: '=',
        trainingName: '=',
        company: '='
    },
    template: `
        <div style="margin:-40px -20px;">
            <div style="min-height:100vh; height:100%;">
            <courses-authoring-tool-view
                company="vm.company"
                view-only="1"
                material-submission="vm.materialSubmission"
                uib-modal-instance="vm.uibModalInstance"
            />
            </div>

            <div class="modal-footer">
                <ul class="actions01">
                    <li class="primary">
                        <button
                            class="btn main"
                            type="button"
                            ng-click="vm.uibModalInstance.dismiss()"
                        >{{ 'general.Ok' | translate }}</button>
                    </li>
                </ul>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, $sce, ModalService, $state) {
        this.$translate = $translate;
        this.$sce = $sce;
        this.ModalService = ModalService;
        this.$state = $state;

        // fake material submission
        // vm.materialSubmission.occurrenceTraining.training.activeI18n.name
        this.materialSubmission = {
            material: this.material,
            occurrenceTraining: {
                training: {
                    activeI18n: {
                        name: this.trainingName
                    }
                }
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/version/training/materialPreview/index.js